import { flux } from '@/core/flux.module';
import { errorToast } from '@/utilities/toast.utilities';
import { sqTableDefinitionsApi } from '@/sdk';
import type { ExtensionSchema } from '@/vantage/types/Extension.types';
import { SimplifiedNode } from '@/vantage/types/SimplifiedNode.types';

export const fetchEvidenceTableDefinition = async (id: string): Promise<void> => {
  try {
    const { data: evidenceTableDefinition } = await sqTableDefinitionsApi.getTableDefinition({ id });
    flux.dispatch('SET_EVIDENCE_TABLE_DEFINITION', { evidenceTableDefinition });
  } catch (e) {
    errorToast({ httpResponseOrError: e });
  }
};

export const setExtensions = (extensions: ExtensionSchema[]) => {
  try {
    flux.dispatch(
      'SET_EXTENSIONS',
      extensions.filter(({ enabled }) => enabled),
    );
  } catch (error) {
    errorToast({ httpResponseOrError: error });
  }
};

export const setSelectedNodes = (selectedNodes: SimplifiedNode[]) => {
  flux.dispatch('SET_SELECTED_NODES', { selectedNodes });
};

export const setActiveExtensions = (activeExtensions: string[]) => {
  flux.dispatch('SET_ACTIVE_EXTENSIONS', { activeExtensions });
};

export const markContextModified = () => {
  flux.dispatch('SET_CONTEXT_LAST_MODIFIED', { contextLastModified: Date.now() });
};

export const setConditionMonitorJobPercentComplete = (percentComplete: number | undefined) => {
  flux.dispatch('SET_CONDITION_MONITOR_JOB_PERCENT_COMPLETE', { percentComplete });
};
